import { datesToISO, parseBoolean } from "@";

// send multi sms payload
export const sendMultiSMSPayload = ({
  toDate,
  isPaid,
  category,
  fromDate,
  projectId,
  messageBody,
  messageType,
  projectAmount,
  GiftProjectId,
  classificationId,
}) => ({
  messageBody,
  toTime: datesToISO(toDate),
  category: parseInt(category),
  isPaid: parseBoolean(isPaid),
  fromTime: datesToISO(fromDate),
  messageType: parseInt(messageType),
  projectId: parseInt(projectId) || null,
  projectAmount: parseInt(projectAmount) || null,
  giftProjectId: parseInt(GiftProjectId) || null,
  classificationId: parseInt(classificationId) || null,
});
